import { LocateFixedIcon, MinusIcon, PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@noor/lib';
import { MapButton } from './map-canvas';

interface OffersMapControlsProps {
  onFit: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  /** Extra classes — the Yandex map lifts the stack above its own logo strip. */
  className?: string | undefined;
}

/** Fit-all + zoom stack, identical for the Yandex and OSM offers maps. */
export function OffersMapControls({
  onFit,
  onZoomIn,
  onZoomOut,
  className,
}: OffersMapControlsProps) {
  const { t } = useTranslation('orders');
  return (
    <div
      className={cn(
        'absolute right-3 bottom-3 z-[1000] flex flex-col gap-1.5',
        className,
      )}
    >
      <MapButton onClick={onFit} label={t('offers.fitAll')}>
        <LocateFixedIcon className="size-4" />
      </MapButton>
      <div className="overflow-hidden rounded-lg border border-border bg-card shadow-sm">
        <MapButton onClick={onZoomIn} label={t('map.zoomIn')} bare>
          <PlusIcon className="size-4" />
        </MapButton>
        <div className="h-px bg-border" />
        <MapButton onClick={onZoomOut} label={t('map.zoomOut')} bare>
          <MinusIcon className="size-4" />
        </MapButton>
      </div>
    </div>
  );
}
